import queryString from "query-string";
import axios from "axios";
import Cookies from "js-cookie";
import { checkForXSS, safeRedirect } from "./queryStringHelper";

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const isUnauthorized = error.response?.status === 401;
        const isLoginPage =
            window.location.pathname.toLowerCase() === "/account/login";
        if (
            isUnauthorized &&
            !error.config?.skipUnauthorizedRedirect &&
            !isLoginPage
        ) {
            const returnUrl = encodeURIComponent(
                "/" + window.location.href.replace(/^(?:\/\/|[^/]+)*\//, "")
            );
            sessionStorage.clear();
            let redirectUrl = checkForXSS(returnUrl);
            redirectUrl = "/Account/Login?ReturnUrl=" + redirectUrl;
            safeRedirect(redirectUrl);
        }
        return Promise.reject(error);
    }
);

const removeAuthHeader = (url) => {
    let token = Cookies.get("_t");
    if (token) {
        return false;
    }
    return url.includes(window.location.origin) || url.startsWith("/");
};

const makeRequest = async (config) => {
    try {
        config.transformRequest = [
            (data, headers) => {
                if (removeAuthHeader(config.url)) {
                    delete headers.common.Authorization;
                }
                return data;
            },
        ];
        const response = await axios.request(config);

        if (config.isPdfDownloadRequest) {
            return new Blob([response.data], {
                type: "application/pdf",
            });
        }

        return {
            response: {
                ok: true,
            },
            data: response.data,
        };
    } catch (error) {
        return {
            response: {
                ok: false,
            },
            error: {
                data: error.response?.data,
                message: error.response?.data
                    ? error.response.data
                    : error.message,
                status: error.status || error.response?.status,
                statusText: error.statusText || error.response?.statusText,
            },
        };
    }
};

const getHeaders = () => {
    let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
    };
    return headers;
};

export const getApiErrorMessage = (result, fallbackMessage) => {
    const errorData = result?.error?.data;

    if (typeof errorData === "string" && errorData.trim()) {
        return errorData;
    }

    if (Array.isArray(errorData?.errors) && errorData.errors.length > 0) {
        return errorData.errors[0];
    }

    if (typeof errorData?.error === "string" && errorData.error.trim()) {
        return errorData.error;
    }

    if (typeof errorData?.message === "string" && errorData.message.trim()) {
        return errorData.message;
    }

    if (
        typeof result?.error?.message === "string" &&
        result.error.message.trim()
    ) {
        return result.error.message;
    }

    return fallbackMessage;
};

export const request = (url, method, bodyObj, pdfHeader = false) => {
    let requestParams = {
        url,
        method,
        headers: getHeaders(),
        data: bodyObj ? JSON.stringify(bodyObj) : null,
        isPdfDownloadRequest: false,
    };
    if (pdfHeader) {
        requestParams.headers = {
            "Content-Type": "application/pdf",
            Accept: "application/pdf",
        };
        requestParams.isPdfDownloadRequest = true;
        requestParams.responseType = "arraybuffer";
    }
    return makeRequest(requestParams);
};

export const requestWithHeaders = (
    url,
    method,
    bodyObj,
    header,
    pdfHeader = false,
    requestOptions = {}
) => {
    let requestParams = {
        url,
        method,
        headers: { ...getHeaders(), ...header },
        data: bodyObj ? JSON.stringify(bodyObj) : null,
        isPdfDownloadRequest: false,
        ...requestOptions,
    };
    if (pdfHeader) {
        requestParams.headers = {
            "Content-Type": "application/pdf",
            Accept: "application/pdf",
        };
        requestParams.isPdfDownloadRequest = true;
        requestParams.responseType = "arraybuffer";
    }
    return makeRequest(requestParams);
};

export const requestWithParams = (baseUrl, method, params, bodyObj) => {
    const { url, query } = queryString.parseUrl(baseUrl);
    const newQueryString = queryString.stringify({ ...query, ...params });
    const newURL = newQueryString ? `${url}?${newQueryString}` : url;
    return makeRequest({
        url: newURL,
        method,
        headers: getHeaders(),
        data: bodyObj ? JSON.stringify(bodyObj) : null,
    });
};

export const doGet = (url, params, body) => {
    return params
        ? requestWithParams(url, "GET", params, body)
        : request(url, "GET", body);
};
